import React, { useState, useEffect, useContext } from "react";
import { useHistory,useParams, Link } from 'react-router-dom';
import { Contextone } from '../Context';
import { fetchGetPages } from "../Api";


function FooterLink() {
  const {page_name} = useParams();
  const [page, setpage] = useState([]);
  const history = useHistory();
  const countercontext = useContext(Contextone);
  const url = countercontext.isDomain;
  const apiUrl = `https://${url}`;

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const data = await fetchGetPages(apiUrl);
        setpage(data.result);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchPages();
  }, []);

  return (
    page.map((mtype, index) => (
    <div key={mtype.id}>
      {page_name == mtype.page_name.replace(/\s+/g, '') ? (
        <>
        {url === 'admin.aaryaadigital.com' ? 
         page_name === 'AuditionForm' ? 
          <iframe width="100%" height="800px" src={'https://admin.aaryaadigital.com/audition-app'} style={{marginTop:'75px'}}></iframe>:
          <iframe width="100%" height="800px" src={`${apiUrl}${mtype.url}`} style={{marginTop:'75px'}}></iframe> :
          <iframe width="100%" height="800px" src={`${apiUrl}${mtype.url}`} style={{marginTop:'75px'}}></iframe>}
        </>
        ): ''}
    </div>
    ))
  );
}

export default FooterLink;